import script from "./MultiselectUI.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiselectUI.vue?vue&type=script&setup=true&lang=ts"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__